const render = () => {
    return `
        <div class="page-loading">
            <div class="sprite-frame"></div>
        </div>
    `;
};

export default render;
